import { useContext } from "react";
import emptyImage from "../assets/media/activity-empty-state.png";
import { activityContext } from "../pages/Dashboard";
const ActivityEmpty = () => {
  const { addActivity } = useContext(activityContext);
  return (
    <div className="h-[calc(100vh-150px)]">
      <img
        data-cy="activity-empty-state"
        onClick={() => addActivity()}
        src={emptyImage}
        className="cursor-pointer md:w-[765px]"
        alt="activity empty"
      />
    </div>
  );
};

export default ActivityEmpty;
